import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Body, Heading, Box } from '@hover/blueprint';
import { IProjectVision } from '../interfaces/IProjectVision';
import HowDoesItWorkQuickerJobVector from '../assets/svgs/HowDoesItWorkQuickerJobVector';

const PROJECT_VISIONS: IProjectVision[] = [
  {
    title: 'designing',
    header: 'Design in 3D on Your Actual (ok, Virtual) Home',
    body: 'Super fun part: Use the design tools in our app to change colors, roof style, siding type, windows and more with real products on your home’s 3D model. Pretty cool, huh?',
    secondBody:
      'Collaborate with your contractor on design decisions, material selections, and other project plans.',
    id: 0,
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="faster measurements"
        src="../assets/images/how_does_it_work_designing.png"
        width={378}
        height={560}
      />
    ),
  },
  {
    title: 'estimating',
    header: 'More Accurate Estimates Made Simple',
    body: 'Accurate measurements result in the most accurate estimates and fewer unexpected costs later.',
    secondBody:
      'HOVER helps contractors and insurers estimate project and repair costs with confidence for the fairest deal in the shortest amount of time.',
    id: 1,
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        alt="faster measurements"
        src="../assets/images/how_does_it_work_estimation.png"
        width={480}
        height={480}
      />
    ),
  },
  {
    title: 'project management',
    header: 'Quicker Job Completions',
    body: 'Your project gets done more quickly with HOVER’s fast measurements, estimating, and ordering.',
    secondBody:
      'HOVER simplifies getting the job done, so you can get to your “better” fast and with less stress.',
    id: 2,
    image: (
      <Box position="relative">
        <Box w={{ base: '100%', tablet: 'auto' }} px={200}>
          <HowDoesItWorkQuickerJobVector width="100%" />
        </Box>
        <Box
          flexDir="column"
          alignItems="center"
          position="absolute"
          top="150px"
          left="50%"
          translateX="-50%"
          transform="auto"
          maxW="280px"
        >
          <Body
            textAlign="center"
            letterSpacing="1px"
            size={300}
            isBold
            color="neutral.0"
            mb={200}
          >
            3D MODELS AND MEASUREMENTS RETURNED IN UNDER 24 HOURS:
          </Body>
          <Heading
            size={{ base: 600, tablet: 700, desktop: 800 }}
            isDisplay
            color={{ base: 'neutral.0', desktop: 'neutral.0' }}
          >
            99.4%
          </Heading>
        </Box>
      </Box>
    ),
  },
];

export default PROJECT_VISIONS;
